export const HomeHeaderItemType = {
  MarketingBanner: 'marketing_banner', // 首页banner
  KingKong: 'king_kong', // 金刚
  TaskBanner: 'task_banner', // 任务banner
  FixedPriceBanner: 'fixed_price', // 一口价
  ShopBanner: 'shop_banner', // 店铺banner
  NewUserCouponBanner: 'new_user_coupon' // 已废弃
};

// 首页CID
export const HomePageCid = 'c_waimai_c_overseas_aatucy3n';

export const HeaderMVBid = {
  MarketingBannerItem: 'b_waimai_c_overseas_bm9ltrr5_mv', // 运营banner
  KingKong: 'b_sailor_c_to51typd_mv', // 金刚区
  KingKongItem: 'b_sailor_c_eactcvtd_mv', // 金刚区-金刚位
  // 无引用
  ShopBanner: 'b_sailor_c_yoo5s57e_mv', // 店铺专区整体
  // 无引用
  ShopBannerCard: 'b_sailor_c_1jn2ansd_mv', // 店铺专区商家卡片
};

export const HeaderMCBid = {
  MarketingBannerItem: 'b_waimai_c_overseas_bm9ltrr5_mc', // 运营banner
  KingKongItem: 'b_sailor_c_eactcvtd_mc', // 金刚区-金刚位
  ShopBannerTitle: 'b_sailor_c_pwop0gdc_mc', // 店铺专区-标题
  // 无引用
  ShopBannerMoreBtn: 'b_sailor_c_tabms33r_mc', // 店铺专区-查看更多
};

export const HeaderViewBgImageBid = {
  HeaderViewBgImageView: 'b_sailor_c_kqh0xepa_mv', // 首页氛围曝光
};
